import Vue from "vue";

export default function useVue() {
	Vue.prototype.$appName = "Libri35";
	Vue.config.productionTip = false;
	Vue.config.silent = true;
}
